import type { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import { reviewData } from '../review-data';
import { buildReviewListSchema, type ReviewItem } from '../review-schema.util';
import type { ReviewVariantSchemaData } from '../star-reviews/star-reviews.schema';

const VARIANT_ID_FRAGMENT = 'reviews-columns-type2';
const DEFAULT_LIST_NAME = 'Customer Testimonials';

/**
 * Returns Review nodes + an ItemList for the column-type2-reviews variant. Reviews are
 * sourced from `reviewData[3]`. Items include `image` which we surface as the
 * Person `image` URL on the author.
 */
export function getColumnType2ReviewsSchema(data: ReviewVariantSchemaData | null): SchemaOrgNode[] | null {
  if (!data) return null;
  const items: ReviewItem[] = reviewData[3];
  const nodes = buildReviewListSchema({
    listId: `${data.pageUrl}#${VARIANT_ID_FRAGMENT}`,
    listName: data.reviewTitle?.trim() || DEFAULT_LIST_NAME,
    siteUrl: data.siteUrl,
    organizationName: data.organizationName,
    items,
  });
  if (!nodes) return null;
  return nodes.map((node) => {
    if (node['@type'] !== 'Review') return node;
    const match = node['@id']?.match(/-review-(\d+)$/);
    if (!match) return node;
    const src = items[Number.parseInt(match[1], 10) - 1]?.image?.src;
    if (!src) return node;
    const author = node.author as { '@type': string; name: string };
    return { ...node, author: { ...author, image: src } };
  });
}
